var axios = require('axios');

var decode = require('./decode');

var login = require('./login');
/* expose a more friendly api */


module.exports = function (skywardURL) {
  return function (user, pass) {
    return login(axios, skywardURL)({
      user: user,
      pass: pass
    }).then(decode);
  };
};